export default class ReportToggle {
	constructor(el) {
		this.el = el;
		this.trigger = this.el.querySelector('.report-toggle__trigger');
		this.closeBtn = this.el.querySelector('.report-toggle__close');
		this.dropdown = this.el.querySelector('.report-toggle__dropdown');
		this.body = document.querySelector('body');

		this.init();
		this.events();
	}

	init() {

	}

	events() {
		this.trigger.addEventListener('click', this.open.bind(this));
		this.closeBtn.addEventListener('click', this.close.bind(this));

		document.addEventListener('click', e => {
			if (!e.target.classList.contains('report-toggle__dropdown')
				&& !e.target.classList.contains('report-toggle__close')
				&& !e.target.classList.contains('report-toggle__trigger')) {
				this.close();
			}
		});
	}

	open() {
		this.el.classList.add('open');
	}

	close() {
		this.el.classList.remove('open');
	}

}